import React, { useState } from "react";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro";
import { connect } from "react-redux";
import { useLocation } from 'react-router-dom';

import Header from "../components/Navbar.js";
import Footer from "components/footers/FiveColumnDark.js";
import { SectionHeading } from "components/misc/Headings";
import { PrimaryButton } from "components/misc/Buttons";
import { ReactComponent as StarIcon } from "images/star-icon.svg";

import { 
  CardContainer,
  Card,
  CardImageContainer,
  CardRating,
  CardRatingContainer,
  CardHoverOverlay,
  CardButton,
  CardReview,
  CardText,
  CardTitle,
  CardContent,
  CardPrice, 
} from 'components/cards/TabCardGrid.js';

import TabCardGrid from 'components/cards/TabCardGrid.js'

//elements
const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900`;
const Posts = tw.div`mt-6 sm:-mr-8 flex flex-wrap`;
const PostContainer = styled.div`
  ${tw`mt-10 w-full sm:w-1/2 lg:w-1/3 sm:pr-8`}
  ${props =>
    props.featured &&
    css`
      ${tw`w-full!`}
      ${Post} {
        ${tw`sm:flex-row! h-full sm:pr-4`}
      }
      ${Image} {
        ${tw`sm:h-96 sm:min-h-full sm:w-1/2 lg:w-2/3 sm:rounded-t-none sm:rounded-l-lg`}
      }
      ${Info} {
        ${tw`sm:-mr-4 sm:pl-8 sm:flex-1 sm:rounded-none sm:rounded-r-lg sm:border-t-2 sm:border-l-0`}
      }
      ${Description} {
        ${tw`text-sm mt-3 leading-loose text-gray-600 font-medium`}
      }
    `}
`;
const Post = tw.div`cursor-pointer flex flex-col bg-gray-100 rounded-lg`;
const Image = styled.div`
  ${props => css`background-image: url("${props.imageSrc}");`}
  ${tw`h-64 w-full bg-cover bg-center rounded-t-lg`}
`;
const Info = tw.div`p-8 border-2 border-t-0 rounded-lg rounded-t-none`;
const Category = tw.div`uppercase text-primary-500 text-xs font-bold tracking-widest leading-loose after:content after:block after:border-b-2 after:border-primary-500 after:w-8`;
const CreationDate = tw.div`mt-4 uppercase text-gray-600 italic font-semibold text-xs`;
const Title = tw.div`mt-1 font-black text-2xl text-gray-900 group-hover:text-primary-500 transition duration-300`;
const Description = tw.div``;

const ButtonContainer = tw.div`flex justify-center`;
const LoadMoreButton = tw(PrimaryButton)`mt-16 mx-auto`;

const BlogIndexComponent = (props) => {
  const [visible, setVisible] = useState(7);
  //const urlQueryString = window.location.search.slice(1);//cat=Spices&prod_type=Maggi
  //another version queryString.parse(window.location.search) returns an object;
  //also useLocation().search to get params. returns an object;
  //this.props.params.your_param_name
 
  //const yourParamName = new URL(window.location.href).searchParams.get('yourParamName')
  
  //const urlParams = new URLSearchParams(queryString);
  //const from = urlParams.get('from');
  //other methods:
  //.has('product'), getAll('product'), append('product'), keys(), values(), entries()
  
  const urlParams = new URLSearchParams(useLocation().search);
  const dataToRender = urlParams.get('dataToRender') || '';
  const prod_type = urlParams.get('prod_type') || '';
  const cat = urlParams.get('cat') || '';
  const market = urlParams.get('market') || '';
  const tab = urlParams.get('tab') || '';
  const page = urlParams.get('page') || '';
  const headingText = `${prod_type}: ${cat}`.replace(/_/g, ' ') || '';

  const normalizeValue = (value) => (value ?? '').toString().replace(/[_\s]+/g, '').toLowerCase();


  const onLoadMoreClick = () => {
    setVisible(v => v + 9);
  };
  
  return (
    <>
      <Header />
      <TabCardGrid page={page} />
      {/*<Container>
        <ContentWithPaddingXl>
          <HeadingRow>
            <Heading>{headingText}</Heading>
          </HeadingRow>
          <Posts>
            {posts.slice(0, visible).map((card, index) => (
              <CardContainer key={index}>
                <Card className="group" initial="rest" whileHover="hover" animate="rest"> {/*href={`/components/innerPages/SignupPage?tab=${activeTab}&cat=${card.content}&prod=${card.queryBy}`}*/}
                  {/*<CardImageContainer imageSrc={card.imageSrc}>
                    <CardRatingContainer>
                      <CardRating>
                        <StarIcon />
                        {card.rating}
                      </CardRating>
                      <CardReview>({card.reviews})</CardReview>
                    </CardRatingContainer>
                    <CardHoverOverlay
                      variants={{
                        hover: {
                          opacity: 1,
                          height: "auto"
                        },
                        rest: {
                          opacity: 0,
                          height: 0
                        }
                      }}
                      transition={{ duration: 0.3 }}
                    >
                      <CardButton
                        >Buy Now
                      </CardButton> {/*href={`/components/innerPages/SignupPage?tab=
                        ${activeTab}&cat=${card.content}&prod=${card.queryBy}`}*/}
                    {/*</CardHoverOverlay>
                  </CardImageContainer>
                  <CardText>
                    <CardTitle>{card.title}</CardTitle>
                    <CardContent>{card.content}</CardContent>
                    <CardPrice>From &#8358;{card.price}</CardPrice>
                  </CardText>
                </Card>
              </CardContainer>              
                      ))*/}
            {/*<PostContainer key={index} featured={post?.featured}>
                <Post className="group" as="a" href={post?.url}>
                  <Image imageSrc={post?.imageSrc} />
                  <Info>
                    <Category>{post?.category}</Category>
                    <CreationDate>{post?.date}</CreationDate>
                    <Title>{post?.title}</Title>
                    {post?.featured && post?.description && <Description>{post?.description}</Description>}
                  </Info>
                </Post>
            </PostContainer>*/}
            {/*dataToRender === 'Market' && posts.slice(0, visible).map((post, index) => (
              <PostContainer key={index} featured={post.featured}>
                <Post className="group" as="a" href={post.url}>
                  <Image imageSrc={post.imageSrc} />
                  <Info>
                    <Category>{post.category}</Category>
                    <CreationDate>{post.date}</CreationDate>
                    <Title>{post.title}</Title>
                    {post.featured && post.description && <Description>{post.description}</Description>}
                  </Info>
                </Post>
              </PostContainer>
            ))}
            {dataToRender === 'Category' && posts.slice(0, visible).map((post, index) => (
              <PostContainer key={index} featured={post.featured}>
                <Post className="group" as="a" href={post.url}>
                  <Image imageSrc={post.imageSrc} />
                  <Info>
                    <Category>{post.category}</Category>
                    <CreationDate>{post.date}</CreationDate>
                    <Title>{post.title}</Title>
                    {post?.featured && post?.description && <Description>{post?.description}</Description>}
                  </Info>
                </Post>
              </PostContainer>
            ))*/}
          {/*</Posts>
          {visible < posts.length && (
            <ButtonContainer>
              <LoadMoreButton onClick={onLoadMoreClick}>Load More</LoadMoreButton>
            </ButtonContainer>
          )}
        </ContentWithPaddingXl>
      </Container>*/}
      <Footer />
    </>
  );
};


const BlogIndex = connect(state => ({      
  //foodCategorySellers: state,
  //marketOwnerOffers: state,
  foodSellersData: state.TabCardGridData
}))(BlogIndexComponent);

export default BlogIndex;